// extracted by mini-css-extract-plugin
export default {"stack-item":"styles_stack-item__6+m0U","stack-item-header":"styles_stack-item-header__06Qnm"};